import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { ListGroup, ListGroupItem } from 'reactstrap';
import { getCmsListH } from '../../actions/cmsActions';

class CmsLinksHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showButton: window.innerWidth <= 575,
      showMenu: window.innerWidth > 575,
    };
  }

  componentDidMount() {
    let { getCmsLists, category } = this.props;
    getCmsLists(category);

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.setState({
      showButton: window.innerWidth <= 575,
    });
  };

  toggleMenu = () => {
    this.setState((prevState) => ({
      showMenu: !prevState.showMenu,
    }));
  };

  render() {
    let { fetching, data } = this.props.cms;
    const { showButton, showMenu } = this.state;

    return (
      <div>
        {fetching ? null : (
          <div>
            {showButton && (
              <button className='button-bloc mb-4' onClick={this.toggleMenu}>
                <i className="fas fa-reorder"></i>
              </button>
            )}
            {showMenu && (
              <div className='list-bloc'>
                <ListGroup>
                  {data.map((item, key) => (
                    <ListGroupItem key={key}>
                      <Link to={`/cms/${item.id}-${item.link_rewrite[0].value}`}>
                        {item.meta_title[0].value}
                      </Link>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps({ cmsReducer }) {
  return {
    cms: cmsReducer.cmsLinksHeader,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getCmsLists: bindActionCreators(getCmsListH, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CmsLinksHeader);



// WEBPACK FOOTER //
// ./src/components/cms/CmsLinksHeader.js